import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import "react-quill/dist/quill.snow.css";
import {
  Send,
  Mail,
  Calendar,
  Users,
  DollarSign,
  Crown,
  Loader2,
  ChevronDown,
  Sparkles,
  CheckCircle,
  BarChart,
  Clock,
  MessageSquare,
} from "lucide-react";
import "./MailToPaidUser.css";

function MailToPaidUsers({ match }) {
  const [value, setValue] = useState("");
  const [subject, setSubject] = useState("");
  const [sendVia, setSendVia] = useState("");
  const [date, setDate] = useState("2025-01-01");
  const [loader, setLoader] = useState(false);

  // Stats data - you can replace with actual data from your API
  const [stats, setStats] = useState({
    totalPaidUsers: 1,
    activeSubscribers: 0,
    verifiedPayments: 0,
    monthlyRevenue: 0,
  });

  useEffect(() => {
    // You can fetch actual stats here
    setStats({
      totalPaidUsers: 1567,
      activeSubscribers: 1450,
      verifiedPayments: 1200,
      monthlyRevenue: 890,
    });
  }, []);

  const handleSubmit = async () => {
    try {
      if (value && subject && sendVia) {
        setLoader(true);
        let payload = {
          template: value,
          subject: subject,
          date: date,
          sendVia: sendVia,
        };
        const userData = await api.sendMailToPaidUser(payload);
        if (userData.success) {
          alert(userData.message);
          setLoader(false);
        } else {
          alert("Something went wrong, email not sent ");
          setLoader(false);
        }
      } else {
        setLoader(false);
        alert("Please insert fields");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong, email not sent ");
    }
  };

  var Editor = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <>

      <div className="email-dashboard">
        {/* Header with integrated stats - EXACTLY like second image */}
        <div className="dashboard-header-container">
          <div className="header-main">
            <div className="header-icon">
              <Crown size={22} />
            </div>
            <div className="contents-of-the-header">
              <h1>Send Mail To Paid Users</h1>
              <p>Send exclusive emails to your premium subscribers</p>
            </div>
          </div>

          {/* Stats Grid integrated in header - EXACT layout as second image */}
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon stat-icon-1">
                <DollarSign size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.totalPaidUsers.toLocaleString()}</h3>
                <p>PAID USERS</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon stat-icon-2">
                <Users size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.activeSubscribers.toLocaleString()}</h3>
                <p>ACTIVE SUBSCRIBERS</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon stat-icon-3">
                <CheckCircle size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.verifiedPayments.toLocaleString()}</h3>
                <p>VERIFIED PAYMENTS</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon stat-icon-4">
                <BarChart size={24} />
              </div>
              <div className="stat-info">
                <h3>${stats.monthlyRevenue.toLocaleString()}</h3>
                <p>MONTHLY REVENUE</p>
              </div>
            </div>
          </div>
        </div>

        {/* Email Form Card */}
        <div className="email-card">
          <div className="cards-header">
            <div className="card-icon">
              <Send size={20} />
            </div>
            <h2>Compose Premium Email</h2>
          </div>

          <div className="form-group">
            <label>
              <Mail size={16} />
              Email Subject
            </label>
            <input
              type="text"
              className="form-control"
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Subject..."
            />
          </div>

          <div className="form-group">
            <label>
              <Calendar size={16} />
              Send mail to user, whose subscribed from...
            </label>
            <div className="date-wrapper">
              <input
                type="date"
                value={date}
                className="form-control"
                onChange={(e) => setDate(e.target.value)}
              />
              {/* <div className="date-icon">
                <Calendar size={20} />
              </div> */}
            </div>
          </div>

          <div className="form-group">
            <label>
              <Send size={16} />
              Send Via
            </label>
            <div className="select-wrapper">
              <select
                name="category"
                onChange={(e) => setSendVia(e.target.value)}
                className="form-control"
              >
                <option value="">Send Via</option>
                <option value="noreply">noreply@waqarzaka.net</option>
                <option value="info">info@waqarzaka.net</option>
              </select>
              <div className="select-arrow">
                <ChevronDown size={20} />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>
              <Sparkles size={16} />
              Email Content
            </label>
            <div className="editor-container">
              <ReactQuill
                placeholder="Add Email description"
                modules={Editor}
                theme="snow"
                value={value}
                onChange={setValue}
              />
            </div>
          </div>

          <div className="button-group">
            <button onClick={handleSubmit} className="btn btn-primary">
              <Send size={18} />
              Send Mail to Paid Users
            </button>
          </div>
        </div>

        {loader && (
          <div className="loader-overlay">
            <div className="loader-content">
              <Loader2 size={48} className="loader-spinner" />
              <p className="loader-text">Sending premium emails...</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default MailToPaidUsers;
